import React, { useState } from "react";
import API from "../axios";
import "../App.css";
import { Toast, ToastContainer, Spinner } from "react-bootstrap";

const Feedback = () => {
  const empDetails = JSON.parse(
    localStorage.getItem("empDetails") || "{}"
  );

  const [feedback, setFeedback] = useState("");
  const [loading, setLoading] = useState(false);

  // TOAST
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success"
  });

  const showToast = (message, type = "success") => {
    setToast({
      show: true,
      message,
      type
    });
  };

  const handleSubmit = async () => {
    if (!feedback.trim()) {
      showToast("Please enter feedback", "danger");
      return;
    }

    try {
      setLoading(true);

      const res = await API.post("/feedback", {
        empid: empDetails.employee_code,
        name: empDetails.emp_name,
        feedback
      });

      if (res.data.success) {
        showToast(res.data.message, "success");
        setFeedback("");
      } else {
        showToast("Failed to submit feedback", "danger");
      }

    } catch (err) {
     console.error(err);

      showToast(
        err?.response?.data?.message ||
        "Failed to submit feedback",
        "danger"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* PAGE LOADER */}
      {loading && (
        <div className="page-loader-feedback">
          <Spinner animation="border" variant="light" />
        </div>
      )}

      {/* TOASTER */}
      <ToastContainer
        position="top-end"
        className="p-3"
        style={{ zIndex: 9999 }}
      >
        <Toast
          bg={toast.type}
          onClose={() =>
            setToast({ ...toast, show: false })
          }
          show={toast.show}
          delay={3000}
          autohide
        >
          <Toast.Body className="text-white fw-semibold">
            {toast.message}
          </Toast.Body>
        </Toast>
      </ToastContainer>

      <div className="feedback-page">
        <div className="feedback-card">
          <h3 className="feedback-title">
            We value your opinion.
          </h3>

          <p className="feedback-text">
            Kindly take a moment to tell us what you think.
          </p>

          {/* TEXTAREA */}
          <textarea
            className="feedback-input"
            placeholder="Write your feedback here..."
            value={feedback}
            onChange={(e) =>
              setFeedback(e.target.value)
            }
          />

          {/* BUTTON */}
          <button
            className="feedback-btn"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Submitting...
              </>
            ) : (
              "Share my feedback"
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default Feedback;